export default __webpack_public_path__ + "static/media/contact-us.1035ce90.svg";